import { render, staticRenderFns } from "./GuideNotification.vue?vue&type=template&id=076d0c24&scoped=true&"
import script from "./GuideNotification.vue?vue&type=script&lang=js&"
export * from "./GuideNotification.vue?vue&type=script&lang=js&"
import style0 from "./GuideNotification.vue?vue&type=style&index=0&id=076d0c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076d0c24",
  null
  
)

export default component.exports